import * as React from 'react'
import { SettingsPage } from '@sales-center/components'
import Stack from '@mui/material/Stack'
import { ActivityTypesList, ActivityTypesForm } from './components'
import { ActivityTypesContextProvider } from './context'

export function ActivityTypes() {
  return (
    <ActivityTypesContextProvider>
      <SettingsPage title="Activities" padding="40px">
        <Stack direction="row" justifyContent="center">
          <ActivityTypesList />
          <ActivityTypesForm />
        </Stack>
      </SettingsPage>
    </ActivityTypesContextProvider>
  )
}
